function u(e) {
  for (var l = -1, r = e == null ? 0 : e.length, n = {}; ++l < r; ) {
    var t = e[l];
    n[t[0]] = t[1];
  }
  return n;
}
export {
  u as default
};
